/* OperationsForms.jsx */
import React, { useState, useEffect, useRef } from 'react';
import {
    PhoneCall, Mail, MessageSquare, Mic,
    FileEdit, Upload, ClipboardCheck,
    Calendar, Percent, Settings, X, RotateCcw
} from 'lucide-react';
import API_ENDPOINTS from '../../../../config/apiEndpoints';
import './OperationsForms.css';

const OperationsForms = ({ mode, onBack, task, leadInfo: initialLeadInfo, onSuccess }) => {
    // Constants
    const TOKEN = API_ENDPOINTS.TOKE.UNIVERSAL_TOKEN;
    const NEW_BASE_URL = (process.env.REACT_APP_SERVICES_AZURE_BASEURL || '').replace(/\/$/, '');
    const KIT19 = (process.env.REACT_APP_ASSETS_BASE_URL || '').replace(/\/$/, '');
    const API_BASE = (process.env.REACT_APP_WCF_API_BASE_URL || '').replace(/\/$/, '');
    const API_BASE1 = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');

    const FROM_MAIL_IDS = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.NEW_GET_FROM_MAIL_ID}`;
    const Template_for_main = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.NEW_GET_TEMPLATE_FOR_MAIL}`;
    const Send_Sms = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.NEW_SEND_SMS}`;
    const Send_voice = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.NEW_SEND_VOICE}`;
    const add_voice = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.ADD_VOICE}`;
    const Add_Notes = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.ADD_NOTES}`;
    const Pipeline_stage = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.PIPELINE_STAGE_BASED_ON_DEALPIPELINE}`;
    const save_deal = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.SAVE_DEAL}`;
    const GetWebFormListByUserId = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.GET_WEBFORM_LIST_BYUSERID}`;
    const url1 = `${API_BASE}${API_ENDPOINTS.APPOINTMENTS.FOLLOWUPSTATUS_LIST}`;
    const url2 = `${API_BASE}${API_ENDPOINTS.APPOINTMENTS.GET_USER_HIRERARCHY_LIST}`;
    const url3 = `${API_BASE1}/${API_ENDPOINTS.APPOINTMENTS.PRODUCT_SUGGESTION_FOR_FOLLOWUP}`;
    const SENDERID = `${API_BASE1}/${API_ENDPOINTS.APPOINTMENTS.GET_SENDER_IDFOR_SMS}`;
    const url4 = `${API_BASE}${API_ENDPOINTS.TASKS.GET_SALES_ACTIVITY_TYPE}`;
    const url5 = `${API_BASE}${API_ENDPOINTS.APPOINTMENTS.GET_USERLIST_PHYSICALAPP_VIEW}`;
    const Send_mail = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.NEW_SEND_MAIL}`;
    const ADD_TASK_APPOINTMENT = `${NEW_BASE_URL}${API_ENDPOINTS.TASKS.INSERT_NEW_TASK_OR_APPOINTMENT}`;
    const Add_follow_up_DLT = `${NEW_BASE_URL}${API_ENDPOINTS.FOLLOWUPS.ADD_FOLLOWUP_DLT}`;
    const Get_Mail_sms_DLT_ACCOUNT = `${API_BASE1}${API_ENDPOINTS.COMMON.GET_MAIL_SMS_DLT_ACCOUNT}`;
    const NEW_ADDED_BASE_URL = (process.env.REACT_APP_BACKEND_BASEURL_FOR_DEVELOPMENT || '').replace(/\/$/, '');
    const Get_Lead_Details_New = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.PIPELINE.GET_SCORECARD_DETAILS_NEW}`;


    // State
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [leadInfo, setLeadInfo] = useState(initialLeadInfo || null);

    // Form States
    const [followupData, setFollowupData] = useState({
        Status: '1290',
        AssignedTo: '34594',
        Date: new Date().toISOString().split('T')[0],
        Time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
        Remarks: '',
        Products: '',
        IsReAssign: false
    });

    const [sendMailData, setSendMailData] = useState({
        ChooseEmails: [],
        Account: '',
        From: '',
        ReplyTo: '',
        To: '',
        Cc: '',
        MailMode: 'template',
        Subject: '',
        TemplateId: '',
        Body: ''
    });

    const [sendSmsData, setSendSmsData] = useState({
        ChooseNumbers: [],
        Account: '',
        SenderId: '',
        TemplateId: '',
        Message: '',
        IsUnicode: false,
        SmsType: 'Compose'
    });

    const [sendVoiceData, setSendVoiceData] = useState({
        ChooseNumbers: [],
        DnidNo: '',
        AppFlow: '',
        Route: 'trans'
    });

    const [notes, setNotes] = useState('');
    const [uploadData, setUploadData] = useState({ Title: '', File: null, FileName: '' });

    const [addTaskData, setAddTaskData] = useState({
        Title: `NewTask_${new Date().toISOString().replace(/[-:T.Z]/g, '').slice(0, 14)}`,
        Description: '',
        Remarks: '',
        SalesActivityType: '7',
        DueDate: new Date().toISOString().split('T')[0],
        DueTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
        Owner: '34594',
        Collaborators: '39768'
    });

    const [appointmentData, setAppointmentData] = useState({
        Title: `NewAppointment_${new Date().toISOString().replace(/[-:T.Z]/g, '').slice(0, 14)}`,
        ActivityType: '8',
        Description: '',
        Remarks: '',
        StartDate: new Date().toISOString().split('T')[0],
        StartTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
        EndDate: new Date().toISOString().split('T')[0],
        EndTime: new Date(new Date().getTime() + 60 * 60 * 1000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
        Where: '',
        Latitude: '',
        Longitude: '',
        Owner: '41451',
        Collaborators: ''
    });

    const [dealData, setDealData] = useState({
        Amount: '',
        PipelineId: '',
        PipelineStage: '',
        Probability: '',
        DealOwner: '34594',
        ClosureDate: new Date().toISOString().split('T')[0]
    });

    // Options States
    const [followupStatusOptions, setFollowupStatusOptions] = useState([]);
    const [assignedToOptions, setAssignedToOptions] = useState([]);
    const [mailAccounts, setMailAccounts] = useState([]);
    const [fromMailOptions, setFromMailOptions] = useState([]);
    const [mailTemplates, setMailTemplates] = useState([]);
    const [smsAccounts, setSmsAccounts] = useState([]);
    const [smsSenderIds, setSmsSenderIds] = useState([]);
    const [smsTemplates, setSmsTemplates] = useState([]);
    const [dniNumbers, setDniNumbers] = useState([]);
    const [appFlows, setAppFlows] = useState([]);
    const [dealPipelines, setDealPipelines] = useState([]);
    const [dealStages, setDealStages] = useState([]);
    const [salesOwners, setSalesOwners] = useState([]);
    const [webforms, setWebforms] = useState([]);
    const [selectedWebform, setSelectedWebform] = useState('');
    const [salesActivityOptions, setSalesActivityOptions] = useState([]);
    const [collaboratorOptions, setCollaboratorOptions] = useState([]);

    // Dropdown/Search States
    const [smsTab, setSmsTab] = useState('Indian SMS');
    const [productSearchTerm, setProductSearchTerm] = useState('');
    const [suggestedProducts, setSuggestedProducts] = useState([]);
    const [showProductDropdown, setShowProductDropdown] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [scriptsLoaded, setScriptsLoaded] = useState(false);

    const whereInputRef = useRef(null);
    const googleAutocompleteRef = useRef(null);
    const searchTimeout = useRef(null);

    // Initial Data Fetching
    useEffect(() => {
        const leadId = task.LeadId || task.enquiryId || task.leadId || task.id || "2508095";
        if (mode === 'mail') {
            fetchAllMailData(leadId);
        } else if (mode === 'sms') {
            fetchAllSmsData(leadId);
        } else if (mode === 'voice') {
            fetchAllVoiceData(leadId);
        } else if (mode === 'deal') {
            fetchAllDealData();
        } else if (mode === 'fill-webform') {
            fetchWebforms();
        } else if (mode === 'followup') {
            fetchFollowupStatuses();
            fetchSalesOwnersForFollowup();
        } else if (mode === 'task') {
            fetchSalesActivityTypes();
            fetchSalesOwnersForFollowup();
            fetchCollaborators();
        } else if (mode === 'appointment') {
            fetchSalesActivityTypes();
            fetchSalesOwnersForFollowup();
            fetchCollaborators();
            loadGoogleMapsScript();
        }
    }, [mode, task]);

    // Google Maps Handling
    const loadGoogleMapsScript = () => {
        const scriptId = 'google-maps-script';
        const isGoogleMapsReady = () => window.google && window.google.maps && window.google.maps.places;

        if (isGoogleMapsReady()) {
            setScriptsLoaded(true);
            return;
        }

        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script');
            script.id = scriptId;
            script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAO-dLMQIXYLvJeig0dbjeEqytvPg6EMd8&libraries=places&loading=async&callback=initGoogleMapsCallback`;
            script.async = true;
            script.defer = true;
            window.initGoogleMapsCallback = () => setScriptsLoaded(true);
            document.body.appendChild(script);
        } else {
            const checkInterval = setInterval(() => {
                if (isGoogleMapsReady()) {
                    setScriptsLoaded(true);
                    clearInterval(checkInterval);
                }
            }, 100);
            setTimeout(() => clearInterval(checkInterval), 10000);
        }
    };

    useEffect(() => {
        if (scriptsLoaded && mode === 'appointment' && whereInputRef.current) {
            googleAutocompleteRef.current = new window.google.maps.places.Autocomplete(whereInputRef.current, {
                types: ['geocode', 'establishment'],
            });

            googleAutocompleteRef.current.addListener('place_changed', () => {
                const place = googleAutocompleteRef.current.getPlace();
                const address = place.formatted_address || place.name;
                setAppointmentData(prev => ({
                    ...prev,
                    Where: address,
                    Latitude: place.geometry?.location?.lat() || '',
                    Longitude: place.geometry?.location?.lng() || ''
                }));
            });
        }
    }, [scriptsLoaded, mode]);

    // Fetching Functions
    const fetchLeadDetails = async (leadId, isForSms = false) => {
        try {
            const payload = {
                Token: TOKEN,
                Details: {
                    LeadId: parseInt(leadId, 10),
                    ParentId: localStorage.getItem('userId') || '34594'
                }
            };
            const response = await fetch(Get_Lead_Details_New, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=UTF-8" },
                body: JSON.stringify(payload),
            });
            if (response.ok) {
                const result = await response.json();
                if (result.Details) {
                    const inner = typeof result.Details === 'string' ? JSON.parse(result.Details) : result.Details;
                    const raw = Array.isArray(inner) ? inner[0] : (inner || {});

                    // Same mapping as AppointmentDetails.jsx fetchEntityDetails
                    const mappedData = {
                        ...raw,
                        LeadId: raw.leadid || raw.LeadId || raw.LeadID || '',
                        LeadNo: raw.leadno || raw.leadnumber || raw.LeadNo || raw.LeadNumber || raw.leadNo || '',
                        personname: raw.personname || raw.Name || '',
                        MobileNo: raw.mobileno || raw.Mobile || raw.phones || '',
                        Email: raw.emailid || raw.Email || raw.emails || '',
                        Phones: raw.mobileno || raw.Mobile || raw.phones || '',
                        Emails: raw.emailid || raw.Email || raw.emails || ''
                    };

                    setLeadInfo(mappedData);
                    if (isForSms) {
                        const allNumbers = [mappedData.MobileNo, mappedData.Phones].filter(Boolean);
                        setSendSmsData(prev => ({ ...prev, ChooseNumbers: allNumbers.slice(0, 1) }));
                        setSendVoiceData(prev => ({ ...prev, ChooseNumbers: allNumbers.slice(0, 1) }));
                    } else {
                        const emails = [mappedData.Email, mappedData.Emails].filter(Boolean);
                        setSendMailData(prev => ({ ...prev, ChooseEmails: emails, To: emails[0] || '' }));
                    }
                    return mappedData;
                }
            }
        } catch (error) { console.error("Error fetching lead details:", error); }
        return null;
    };

    const fetchFollowupStatuses = async () => {
        try {
            const uid = localStorage.getItem('userId') || '34594';
            const response = await fetch(url1, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=UTF-8" },
                body: JSON.stringify({ strParentID: uid })
            });
            if (response.ok) {
                const result = await response.json();
                const data = result.d || [];
                setFollowupStatusOptions(data);
                if (data.length > 0) {
                    const defaultStatus = data.find(s => s.Value && s.Value.startsWith('1290')) || data[0];
                    setFollowupData(prev => ({ ...prev, Status: defaultStatus.Value.split(',')[0] }));
                }
            }
        } catch (error) { console.error("Error fetching statuses:", error); }
    };

    const fetchSalesOwnersForFollowup = async () => {
        try {
            const uid = localStorage.getItem('userId') || '34594';
            const response = await fetch(url2, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=UTF-8" },
                body: JSON.stringify({ userid: parseInt(uid, 10) })
            });
            if (response.ok) {
                const result = await response.json();
                setAssignedToOptions(result.d || []);
            }
        } catch (error) { console.error("Error fetching owners:", error); }
    };

    const fetchMailAccounts = async () => {
        try {
            const uid = localStorage.getItem('userId') || '34594';
            const payload = { Token: TOKEN, Message: "", LoggedUserId: uid, Details: { ParentId: parseInt(uid, 10), isSMS: false } };
            const response = await fetch(Get_Mail_sms_DLT_ACCOUNT, {
                method: "POST",
                headers: { "Content-Type": "application/json; charset=UTF-8", "universal-token": TOKEN },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                const accounts = result.Details || [];
                setMailAccounts(accounts);
                if (accounts.length > 0) {
                    const id = accounts[0].AccountId || accounts[0].AccountID || accounts[0].Code || accounts[0].Id;
                    setSendMailData(prev => ({ ...prev, Account: id }));
                }
            }
        } catch (error) { console.error("Error fetching mail accounts:", error); }
    };

    const fetchFromMailIds = async () => {
        try {
            const userId = localStorage.getItem("userId") || '34594';
            const response = await fetch(FROM_MAIL_IDS, {
                method: "POST",
                headers: { "Content-Type": "application/json; charset=UTF-8", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify({ Token: TOKEN, Details: { UserId: Number(userId) } })
            });
            if (response.ok) {
                const result = await response.json();
                const options = result.Details || [];
                setFromMailOptions(options);
                if (options.length > 0) {
                    const val = options[0].Value || options[0].Email || '';
                    setSendMailData(prev => ({ ...prev, From: val, ReplyTo: val }));
                }
            }
        } catch (error) { console.error("Error fetching from mail ids:", error); }
    };

    const fetchMailTemplates = async () => {
        try {
            const userId = localStorage.getItem("userId") || '34594';
            const response = await fetch(Template_for_main, {
                method: "POST",
                headers: { "Content-Type": "application/json; charset=UTF-8", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify({ Token: TOKEN, Details: { ParentId: Number(userId), isSMS: 0, isMail: 1 } })
            });
            if (response.ok) {
                const result = await response.json();
                setMailTemplates(result.Details || []);
            }
        } catch (error) { console.error("Error fetching mail templates:", error); }
    };

    const fetchSmsAccounts = async () => {
        try {
            const userId = localStorage.getItem('userId') || '34594';
            const payload = { Token: TOKEN, Details: { ParentId: userId, IsSms: true } };
            const response = await fetch(Get_Mail_sms_DLT_ACCOUNT, {
                method: "POST",
                headers: { "Content-Type": "application/json", "universal-token": TOKEN },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                const accounts = result.Details || [];
                setSmsAccounts(accounts);
                if (accounts.length > 0) {
                    setSendSmsData(prev => ({ ...prev, Account: accounts[0].Code || accounts[0].Id }));
                }
            }
        } catch (error) { console.error("Error fetching sms accounts:", error); }
    };

    const fetchSmsSenderIds = async () => {
        try {
            const userId = localStorage.getItem('userId') || '34594';
            const response = await fetch(SENDERID, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ Token: TOKEN.toString(), Details: { UserId: userId } })
            });
            if (response.ok) {
                const result = await response.json();
                setSmsSenderIds(result.Details || []);
            }
        } catch (error) { console.error("Error fetching sender ids:", error); }
    };

    const fetchSmsTemplates = async () => {
        try {
            const userId = localStorage.getItem('userId') || '34594';
            const response = await fetch(Template_for_main, {
                method: "POST",
                headers: { "Content-Type": "application/json; charset=UTF-8", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify({ Token: TOKEN, Details: { ParentId: Number(userId), isSMS: 1, isMail: 0 } })
            });
            if (response.ok) {
                const result = await response.json();
                setSmsTemplates(result.Details || []);
            }
        } catch (error) { console.error("Error fetching sms templates:", error); }
    };

    const fetchDniNumbers = async () => {
        try {
            const uid = localStorage.getItem('userId') || '34594';
            const payload = {
                Token: TOKEN,
                Details: {
                    ParentId: Number(uid),
                    AppId: 2,
                    Opt: 0
                }
            };
            const response = await fetch(Send_voice, {
                method: 'POST',
                headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                if (result.Details) {
                    setDniNumbers(result.Details);
                    if (result.Details.length > 0) {
                        setSendVoiceData(prev => ({ ...prev, DnidNo: result.Details[0].Code }));
                    }
                }
            }
        } catch (error) { console.error("Error fetching DNI numbers:", error); }
    };

    const fetchAppFlows = async () => {
        try {
            const uid = localStorage.getItem('userId') || '34594';
            const payload = {
                Token: TOKEN,
                Details: {
                    ParentId: Number(uid),
                    AppId: 0,
                    Opt: 2
                }
            };
            const response = await fetch(Send_voice, {
                method: 'POST',
                headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                if (result.Details) {
                    setAppFlows(result.Details);
                    if (result.Details.length > 0) {
                        setSendVoiceData(prev => ({ ...prev, AppFlow: result.Details[0].Code || result.Details[0].AppId || result.Details[0].Text }));
                    }
                }
            }
        } catch (error) { console.error("Error fetching App flows:", error); }
    };

    const fetchSalesActivityTypes = async () => {
        try {
            const uid = localStorage.getItem('userId') || '34594';
            const response = await fetch(url4, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=UTF-8" },
                body: JSON.stringify({ strTimeZone: "India Standard Time", userid: uid })
            });
            if (response.ok) {
                const result = await response.json();
                setSalesActivityOptions(result.d || []);
            }
        } catch (error) { console.error("Error fetching activities:", error); }
    };

    const fetchCollaborators = async () => {
        try {
            const uid = localStorage.getItem('userId') || '34594';
            const response = await fetch(url5, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=UTF-8" },
                body: JSON.stringify({ userid: uid })
            });
            if (response.ok) {
                const result = await response.json();
                setCollaboratorOptions(result.d || []);
            }
        } catch (error) { console.error("Error fetching collaborators:", error); }
    };

    const fetchDealPipelines = async () => {
        const pipelines = [
            { Code: "152", Text: "solar" },
            { Code: "536", Text: "Study" },
            { Code: "649", Text: "Sales Pipeline" },
            { Code: "851", Text: "Stock Broking" },
            { Code: "1144", Text: "Skin patient" }
        ];
        setDealPipelines(pipelines);
    };

    const fetchDealStages = async (pipelineId) => {
        try {
            const response = await fetch(Pipeline_stage, {
                method: 'POST',
                headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify({ Token: TOKEN, Details: parseInt(pipelineId, 10) })
            });
            if (response.ok) {
                const result = await response.json();
                setDealStages(result.Details || []);
            }
        } catch (error) { console.error("Error fetching stages:", error); }
    };

    const fetchSalesOwners = async () => {
        try {
            const uid = localStorage.getItem('userId') || '34594';
            const response = await fetch('https://wcfkit19.azurewebsites.net/UserCRMCampaign/Service/ToDoService.asmx/GetUserFromHashed_List', {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=UTF-8" },
                body: JSON.stringify({ userid: uid })
            });
            if (response.ok) {
                const result = await response.json();
                setSalesOwners(result.d || []);
            }
        } catch (error) { console.error("Error fetching owners:", error); }
    };

    const fetchWebforms = async () => {
        try {
            const uid = localStorage.getItem('userId') || '34594';
            const response = await fetch(GetWebFormListByUserId, {
                method: 'POST',
                headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify({ Token: TOKEN, Details: { UserId: Number(uid), PagingSize: 100 } })
            });
            if (response.ok) {
                const result = await response.json();
                setWebforms(result.Details || []);
            }
        } catch (error) { console.error("Error fetching webforms:", error); }
    };

    const fetchAllMailData = async (leadId) => {
        setIsSubmitting(true);
        try {
            await fetchLeadDetails(leadId);
            await fetchMailAccounts();
            await fetchFromMailIds();
            await fetchMailTemplates();
        } finally { setIsSubmitting(false); }
    };

    const fetchAllSmsData = async (leadId) => {
        setIsSubmitting(true);
        try {
            await fetchLeadDetails(leadId, true);
            await fetchSmsAccounts();
            await fetchSmsSenderIds();
            await fetchSmsTemplates();
        } finally { setIsSubmitting(false); }
    };

    const fetchAllVoiceData = async (leadId) => {
        setIsSubmitting(true);
        try {
            await fetchLeadDetails(leadId, true);
            await fetchDniNumbers();
            await fetchAppFlows();
        } finally { setIsSubmitting(false); }
    };

    const fetchAllDealData = async () => {
        setIsSubmitting(true);
        try { await fetchDealPipelines(); await fetchSalesOwners(); } finally { setIsSubmitting(false); }
    };

    // Handler Functions
    const handleProductSearch = async (e) => {
        const term = e.target.value;
        setProductSearchTerm(term);
        if (searchTimeout.current) clearTimeout(searchTimeout.current);
        if (term.length < 2) { setSuggestedProducts([]); return; }

        searchTimeout.current = setTimeout(async () => {
            try {
                const uid = localStorage.getItem('userId') || '34594';
                const response = await fetch(url3, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ Token: "-2295521862261168", Details: { UserId: parseInt(uid, 10), Term: term } })
                });
                if (response.ok) {
                    const resData = await response.json();
                    setSuggestedProducts(resData.Details || []);
                    setShowProductDropdown((resData.Details || []).length > 0);
                }
            } catch (err) { console.error(err); }
        }, 300);
    };

    const handleProductSelect = (product) => {
        if (!selectedProducts.find(p => p.Id === product.Id)) {
            const updated = [...selectedProducts, product];
            setSelectedProducts(updated);
            setFollowupData(prev => ({ ...prev, Products: updated.map(p => p.Id).join(',') }));
        }
        setProductSearchTerm('');
        setShowProductDropdown(false);
    };

    const handleRemoveProduct = (id) => {
        const updated = selectedProducts.filter(p => p.Id !== id);
        setSelectedProducts(updated);
        setFollowupData(prev => ({ ...prev, Products: updated.map(p => p.Id).join(',') }));
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFollowupData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleSendMailChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (name === 'ChooseEmails') {
            const updated = checked ? [...sendMailData.ChooseEmails, value] : sendMailData.ChooseEmails.filter(em => em !== value);
            setSendMailData(prev => ({ ...prev, ChooseEmails: updated, To: updated.join(',') }));
        } else {
            setSendMailData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSendSmsChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (name === 'ChooseNumbers') {
            const updated = checked ? [...sendSmsData.ChooseNumbers, value] : sendSmsData.ChooseNumbers.filter(n => n !== value);
            setSmsTab('Indian SMS');
            setSendSmsData(prev => ({ ...prev, ChooseNumbers: updated }));
        } else if (name === 'TemplateId') {
            const selectedTpl = smsTemplates.find(t => (t.MailTemplateId || t.Code || t.Id)?.toString() === value);
            setSendSmsData(prev => ({
                ...prev,
                TemplateId: value,
                Message: selectedTpl ? (selectedTpl.MailTemplateContent || selectedTpl.Content || selectedTpl.Text || '') : prev.Message,
                IsUnicode: selectedTpl ? !!selectedTpl.IsUnicode : prev.IsUnicode
            }));
        } else {
            setSendSmsData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
        }
    };

    const handleSendVoiceChange = (e) => {
        const { name, value } = e.target;
        if (name === 'ChooseNumbers') setSendVoiceData(prev => ({ ...prev, ChooseNumbers: [value] }));
        else setSendVoiceData(prev => ({ ...prev, [name]: value }));
    };

    const handleAddTaskChange = (e) => {
        const { name, value } = e.target;
        setAddTaskData(prev => ({ ...prev, [name]: value }));
    };

    const handleAppointmentChange = (e) => {
        const { name, value } = e.target;
        setAppointmentData(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) setUploadData({ Title: file.name, File: file, FileName: file.name });
    };

    // Submission Functions
    const handleSaveFollowup = async () => {
        try {
            setIsSubmitting(true);
            const userId = localStorage.getItem('userId') || '34594';
            const leadId = task.LeadId || task.enquiryId || task.leadId || task.id;
            
            // Helper to format date as "22-Mar-2026 10:45:00"
            const formatDateForFup = (dateStr, timeStr) => {
                const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                try {
                    const d = new Date(`${dateStr}T${timeStr}`);
                    if (isNaN(d.getTime())) return "";
                    const day = d.getDate().toString().padStart(2, '0');
                    const month = months[d.getMonth()];
                    const year = d.getFullYear();
                    const hours = d.getHours().toString().padStart(2, '0');
                    const minutes = d.getMinutes().toString().padStart(2, '0');
                    return `${day}-${month}-${year} ${hours}:${minutes}:00`;
                } catch (e) {
                    console.error("Date formatting error:", e);
                    return "";
                }
            };

            const nextStatusDate = formatDateForFup(followupData.Date, followupData.Time);

            const payload = {
                Token: TOKEN,
                Details: {
                    objLeadFollowup_BO: {
                        LeadId: parseInt(leadId, 10),
                        AssignedTo: parseInt(followupData.AssignedTo, 10),
                        ParentID: parseInt(userId, 10),
                        CreatedBy: parseInt(userId, 10),
                        FollowUpStatus: parseInt(followupData.Status, 10),
                        FupValue: `${followupData.Status},0,0`,
                        NextStatusDate: nextStatusDate,
                        Remarks: followupData.Remarks,
                        Products: followupData.Products,
                        AmountPaid: 0,
                        IsReAssign: !!followupData.IsReAssign,
                        NotifyBySMS: false,
                        NotifyByEmail: false,
                        SmsScheduelDateTime: nextStatusDate,
                        EmailScheduelDateTime: nextStatusDate
                    },
                    strDLTTemplateID: "",
                    strUserID: userId,
                    strTimeZone: "India Standard Time",
                    strParentID: userId
                }
            };
            const response = await fetch(Add_follow_up_DLT, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) onSuccess?.();
            else alert("Failed to save followup");
        } catch (err) { console.error(err); } finally { setIsSubmitting(false); }
    };

    const handleSendMail = async () => {
        try {
            setIsSubmitting(true);
            const userId = localStorage.getItem('userId') || '34594';
            const payload = {
                Token: TOKEN || "-2295521862261168",
                Details: {
                    AccountId: parseInt(userId, 10),
                    UserId: parseInt(userId, 10),
                    LeadId: (task.LeadId || task.enquiryId || task.leadId || task.id).toString(),
                    Subject: sendMailData.Subject || "",
                    Messages: sendMailData.MailMode === 'template' ? '' : (sendMailData.Body || ""),
                    SenderName: "CRM",
                    ReplyTo: "",
                    FromMailId: "",
                    EmailIds: [sendMailData.To || ""],
                    TemplateId: parseInt(sendMailData.TemplateId, 10) || 0
                }
            };
            const response = await fetch(Send_mail, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) onSuccess?.();
            else alert("Failed to send mail");
        } catch (err) { console.error(err); } finally { setIsSubmitting(false); }
    };

    const handleSendSms = async () => {
        try {
            if (!sendSmsData.Message) {
                alert('Please enter a message or select a template');
                return;
            }
            if (sendSmsData.ChooseNumbers.length === 0) {
                alert('Please select at least one mobile number');
                return;
            }

            setIsSubmitting(true);
            const userId = localStorage.getItem('userId') || '34594';
            const leadId = task.LeadId || task.enquiryId || task.leadId || task.id;

            const formattedMobiles = sendSmsData.ChooseNumbers.map(n => {
                const clean = n.replace(/\s/g, '').replace(/^\+?91/, '');
                return `91 ${clean}`;
            });

            const payload = {
                Token: TOKEN,
                LoggedUserId: userId,
                MAC_Address: "",
                IP_Address: "",
                BroadcastName: "",
                Details: {
                    LeadId: parseInt(leadId, 10),
                    AccountId: parseInt(userId, 10),
                    SenderId: sendSmsData.SenderId,
                    TemplateId: sendSmsData.TemplateId?.toString() || "",
                    Message: sendSmsData.Message,
                    MobileNos: formattedMobiles,
                    IsUnicode: sendSmsData.IsUnicode,
                    UserId: parseInt(userId, 10)
                }
            };

            console.log("Send SMS Payload (Operations):", payload);

            const response = await fetch(Send_Sms, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                alert("SMS sent successfully!");
                onSuccess?.();
            } else {
                alert("Failed to send SMS");
            }
        } catch (err) {
            console.error("Error sending SMS:", err);
            alert("An error occurred while sending SMS");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSendVoice = async () => {
        if (sendVoiceData.ChooseNumbers.length === 0) {
            alert("Please select at least one mobile number");
            return;
        }
        setIsSubmitting(true);
        try {
            const payload = {
                Token: TOKEN,
                Details: JSON.stringify({
                    Route: sendVoiceData.Route,
                    AppId: Number(sendVoiceData.AppFlow) || 0,
                    CallerId: sendVoiceData.DnidNo,
                    Duration: "",
                    MobileNos: [...new Set(sendVoiceData.ChooseNumbers.map(num => {
                        const cleanNum = num.replace(/\D/g, '');
                        if (cleanNum.length === 10) return `91${cleanNum}`;
                        if (cleanNum.length > 10 && cleanNum.startsWith('91')) {
                            return `91${cleanNum.slice(-10)}`;
                        }
                        return num;
                    }))]
                })
            };
            const response = await fetch(add_voice, {
                method: 'POST',
                headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                if (result.Status === 1) onSuccess?.();
                else alert(result.Message || "Failed to send voice");
            } else alert("Failed to send voice");
        } catch (err) { console.error(err); } finally { setIsSubmitting(false); }
    };

    const handleAddNotes = async () => {
        try {
            setIsSubmitting(true);
            const userId = localStorage.getItem('userId') || '34594';
            const payload = {
                Token: TOKEN,
                Details: {
                    ParentId: userId,
                    EntityId: task.LeadId || task.enquiryId || task.leadId || task.id,
                    EntityName: "Lead",
                    Notes: notes
                }
            };
            const response = await fetch(Add_Notes, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) onSuccess?.();
            else alert("Failed to add notes");
        } catch (err) { console.error(err); } finally { setIsSubmitting(false); }
    };

    const handleAddTask = async () => {
        if (!addTaskData.Title.trim()) {
            alert("Please enter a task title");
            return;
        }
        setIsSubmitting(true);
        try {
            const d = new Date(`${addTaskData.DueDate}T${addTaskData.DueTime}`);
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const formattedEndDate = `${d.getDate().toString().padStart(2, '0')} ${months[d.getMonth()]} ${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;

            const payload = {
                Token: TOKEN || "-2295521862261168",
                Details: {
                    insertUpdateTask: {
                        Id: 0,
                        Title: addTaskData.Title,
                        Description: addTaskData.Description,
                        Remarks: addTaskData.Remarks,
                        Address: "",
                        StartDate: "",
                        AssignedTo: parseInt(addTaskData.Owner) || 0,
                        BySMS: false,
                        CollabratoerUserIds: Array.isArray(addTaskData.Collaborators) ? addTaskData.Collaborators.join('#') : (typeof addTaskData.Collaborators === 'string' ? addTaskData.Collaborators.split(',').join('#') : (addTaskData.Collaborators || "")),
                        CompleteAddress: "",
                        CreatedBy: 0,
                        DLTTemplateIDForNotify: "",
                        DLTTemplateIDForSMSReminder: "",
                        EmailSchedul: "",
                        EmailSchedule: "",
                        EndDate: formattedEndDate,
                        IsActive: true,
                        IsAppointment: false,
                        IsEmail: false,
                        IsSMS: false,
                        IsTask: true,
                        Latitude: "",
                        LeadId: parseInt(task.LeadId || task.enquiryId || task.leadId || task.id || "2508095"),
                        Longitude: "",
                        NotifyMe: false,
                        OutcomesId: 0,
                        SmsSchedule: "",
                        Status: "open",
                        TaskId: parseInt(addTaskData.SalesActivityType) || 0,
                        TaskType: ""
                    },
                    TimeZone: "India Standard Time"
                }
            };
            console.log("Adding Task Payload:", payload);
            const response = await fetch(ADD_TASK_APPOINTMENT, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=UTF-8", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                if (result.Status === 1 || result.insertUpdateTask) onSuccess?.();
                else alert(result.Message || "Failed to add task");
            } else alert("Failed to add task");
        } catch (err) { console.error(err); } finally { setIsSubmitting(false); }
    };

    const handleSaveAppointment = async () => {
        if (!appointmentData.Title.trim()) {
            alert("Please enter a title");
            return;
        }

        setIsSubmitting(true);
        try {
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

            const sd = new Date(`${appointmentData.StartDate}T${appointmentData.StartTime}`);
            const formattedStartDate = `${sd.getDate().toString().padStart(2, '0')} ${months[sd.getMonth()]} ${sd.getFullYear()} ${sd.getHours().toString().padStart(2, '0')}:${sd.getMinutes().toString().padStart(2, '0')}:00`;

            const ed = new Date(`${appointmentData.EndDate}T${appointmentData.EndTime}`);
            const formattedEndDate = `${ed.getDate().toString().padStart(2, '0')} ${months[ed.getMonth()]} ${ed.getFullYear()} ${ed.getHours().toString().padStart(2, '0')}:${ed.getMinutes().toString().padStart(2, '0')}:00`;

            const payload = {
                Token: TOKEN || "-2295521862261168",
                Details: {
                    insertUpdateTask: {
                        Id: 0,
                        Title: appointmentData.Title,
                        Description: appointmentData.Description,
                        Remarks: appointmentData.Remarks,
                        Address: appointmentData.Where,
                        StartDate: formattedStartDate,
                        AssignedTo: parseInt(appointmentData.Owner) || 0,
                        BySMS: false,
                        CollabratoerUserIds: Array.isArray(appointmentData.Collaborators) ? appointmentData.Collaborators.join('#') : (typeof appointmentData.Collaborators === 'string' ? appointmentData.Collaborators.split(',').join('#') : (appointmentData.Collaborators || "")),
                        CompleteAddress: "",
                        CreatedBy: 0,
                        DLTTemplateIDForNotify: "",
                        DLTTemplateIDForSMSReminder: "",
                        EndDate: formattedEndDate,
                        IsActive: true,
                        IsAppointment: true,
                        IsEmail: false,
                        IsSMS: false,
                        IsTask: false,
                        LeadId: parseInt(task.LeadId || task.enquiryId || task.leadId || task.id || "2508095"),
                        Longitude: appointmentData.Longitude || "",
                        Latitude: appointmentData.Latitude || "",
                        NotifyMe: false,
                        OutcomesId: 0,
                        Status: "open",
                        TaskId: parseInt(appointmentData.ActivityType) || 0,
                        TaskType: ""
                    },
                    TimeZone: "India Standard Time"
                }
            };

            const response = await fetch(ADD_TASK_APPOINTMENT, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "X-Requested-With": "XMLHttpRequest",
                    "Accept": "application/json, text/javascript, */*; q=0.01"
                },
                body: JSON.stringify(payload),
            });

            const responseText = await response.text();
            let data;
            try {
                const parsed = JSON.parse(responseText);
                data = parsed.d;
                if (typeof data === 'string' && data.startsWith('{')) {
                    data = JSON.parse(data);
                }
            } catch (e) {
                data = { Message: responseText };
            }

            const isSuccess = response.ok && (
                !data ||
                data === "" ||
                data.IsInserted ||
                (typeof data === 'string' && data.toLowerCase().includes("success")) ||
                (typeof responseText === 'string' && responseText.includes("IsInserted\":true"))
            );

            if (isSuccess) {
                onSuccess?.();
            } else {
                const errorMsg = data?.Message || "Failed to add appointment";
                alert(errorMsg);
            }
        } catch (error) {
            console.error("Error adding appointment:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSaveDeal = async () => {
        if (!dealData.Amount || !dealData.PipelineId || !dealData.PipelineStage || !dealData.Probability || !dealData.ClosureDate) {
            alert("Please fill all required fields marked with *");
            return;
        }

        setIsSubmitting(true);
        try {
            const d = new Date(dealData.ClosureDate);
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const formattedDate = `${d.getDate().toString().padStart(2, '0')} ${months[d.getMonth()]} ${d.getFullYear()}`;

            const uid = localStorage.getItem('userId') || '34594';
            const payload = {
                Status: "",
                Message: "",
                Token: TOKEN,
                Details: {
                    LeadId: (task.LeadId || task.enquiryId || task.leadId || task.id || "13582247").toString(),
                    PipelineId: Number(dealData.PipelineId),
                    PipelineStage: Number(dealData.PipelineStage),
                    Amount: Number(dealData.Amount),
                    ClosureDate: formattedDate,
                    DealOwner: Number(uid), // We might need to use dealData.DealOwner here if the form allows choosing it, but ApptDetails uses uid
                    Probability: dealData.Probability.toString(),
                    UserId: Number(uid)
                }
            };

            if (dealData.DealOwner && dealData.DealOwner !== '') {
                payload.Details.DealOwner = Number(dealData.DealOwner);
            }

            console.log("Saving Deal Payload:", payload);

            const response = await fetch(save_deal, {
                method: 'POST',
                headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify(payload)
            });

            const result = await response.json();

            if (response.ok && result.Status === 1) {
                onSuccess?.();
            } else {
                alert(result.Message || "Failed to save deal");
            }
        } catch (error) {
            console.error("Error saving deal:", error);
            alert("An error occurred while saving the deal");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleDocumentUpload = async () => {
        if (!uploadData.File) return;
        try {
            setIsSubmitting(true);
            const userId = localStorage.getItem('userId') || '34594';
            const formData = new FormData();
            formData.append('hdnHandlerMode', 'UploadDocument');
            formData.append('ParentId', userId);
            formData.append('EntityId', task.LeadId || task.enquiryId || task.leadId || task.id);
            formData.append('EntityName', 'Lead');
            formData.append('Title', uploadData.Title);
            formData.append('File', uploadData.File);

            const response = await fetch(`${KIT19}${API_ENDPOINTS.APPOINTMENTS.ATTCHMENT_HANDLER_ADD_COMMENT}`, {
                method: 'POST',
                body: formData
            });
            if (response.ok) onSuccess?.();
            else alert("Failed to upload document");
        } catch (err) { console.error(err); } finally { setIsSubmitting(false); }
    };

    // Render logic per mode
    const renderForm = () => {
        switch (mode) {
            case 'followup':
                return (
                    <div className="add-followup-card">
                        <div className="add-followup-header"><h3>New Follow-Up Entry</h3></div>
                        <div className="add-followup-body">
                            <div className="form-row">
                                <select name="Status" value={followupData.Status} onChange={handleChange} className="followup-select">
                                    {followupStatusOptions.map((opt, i) => <option key={i} value={opt.Value?.split(',')[0]}>{opt.Text}</option>)}
                                </select>
                            </div>
                            <div className="form-row">
                                <select name="AssignedTo" value={followupData.AssignedTo} onChange={handleChange} className="followup-select">
                                    {assignedToOptions.map((opt, i) => <option key={i} value={opt.Code || opt.Id}>{opt.Text}</option>)}
                                </select>
                            </div>
                            <div className="form-row datetime-row">
                                <input type="date" name="Date" value={followupData.Date} onChange={handleChange} className="followup-input" />
                                <input type="time" name="Time" value={followupData.Time} onChange={handleChange} className="followup-input" />
                            </div>
                            <div className="form-row">
                                <textarea name="Remarks" placeholder="Remarks" value={followupData.Remarks} onChange={handleChange} className="followup-textarea"></textarea>
                            </div>
                            <div className="form-group">
                                <label className="input-label">CHOOSE PRODUCTS *</label>
                                <div className="product-search-container" style={{ position: 'relative' }}>
                                    <div className="selected-products-tags" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', marginBottom: '5px' }}>
                                        {selectedProducts.map(p => (
                                            <span key={p.Id} style={{ background: '#e0f7fa', padding: '2px 8px', borderRadius: '4px', fontSize: '12px' }}>
                                                {p.ProductName || p.Name} <span onClick={() => handleRemoveProduct(p.Id)} style={{ cursor: 'pointer', fontWeight: 'bold' }}>&times;</span>
                                            </span>
                                        ))}
                                    </div>
                                    <input type="text" placeholder="Enter product" value={productSearchTerm} onChange={handleProductSearch} onFocus={() => setShowProductDropdown(true)} className="followup-input" />
                                    {showProductDropdown && suggestedProducts.length > 0 && (
                                        <div className="product-dropdown">
                                            {suggestedProducts.map(p => (
                                                <div key={p.Id} onClick={() => handleProductSelect(p)} style={{ padding: '8px', cursor: 'pointer', borderBottom: '1px solid #eee' }}>{p.ProductName || p.Name}</div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="form-footer">
                                <button className="reset-btn" onClick={onBack}>Cancel</button>
                                <button className="save-btn" onClick={handleSaveFollowup} disabled={isSubmitting}>{isSubmitting ? 'Saving...' : 'Save'}</button>
                            </div>
                        </div>
                    </div>
                );
            case 'mail':
                return (
                    <div className="add-followup-card send-mail-card">
                        <div className="add-followup-header send-mail-header"><h3>Send Mail</h3></div>
                        <div className="add-followup-body send-mail-body">
                            <div className="mail-field-group">
                                <label className="mail-section-label">Choose Emails</label>
                                <div className="mail-checkbox-list">
                                    {[leadInfo?.Email, leadInfo?.Emails].filter(Boolean).map(email => (
                                        <label className="mail-checkbox-item" key={email}>
                                            <input type="checkbox" name="ChooseEmails" value={email} checked={sendMailData.ChooseEmails.includes(email)} onChange={handleSendMailChange} />
                                            {email}
                                        </label>
                                    ))}
                                </div>
                            </div>
                            <div className="mail-field-group">
                                <span className="mail-asterisk">* Account</span>
                                <select name="Account" value={sendMailData.Account} onChange={handleSendMailChange} className="mail-select">
                                    {mailAccounts.map(acc => <option key={acc.Code || acc.Id} value={acc.Code || acc.Id}>{acc.Text || acc.Name || acc.AccountName}</option>)}
                                </select>
                            </div>
                            <div className="mail-field-group">
                                <span className="mail-asterisk">* From</span>
                                <select name="From" value={sendMailData.From} onChange={handleSendMailChange} className="mail-select">
                                    {fromMailOptions.map((opt, i) => <option key={i} value={opt.Value}>{opt.Text}</option>)}
                                </select>
                            </div>
                            <div className="mail-radio-group">
                                <label className="mail-radio-item">
                                    <input type="radio" name="MailMode" value="template" checked={sendMailData.MailMode === 'template'} onChange={handleSendMailChange} /> Template
                                </label>
                                <label className="mail-radio-item">
                                    <input type="radio" name="MailMode" value="compose" checked={sendMailData.MailMode === 'compose'} onChange={handleSendMailChange} /> Compose
                                </label>
                            </div>
                            <div className="mail-field-group">
                                <input type="text" name="Subject" placeholder="Subject" value={sendMailData.Subject} onChange={handleSendMailChange} className="mail-input" />
                            </div>
                            {sendMailData.MailMode === 'template' ? (
                                <div className="mail-field-group">
                                    <select name="TemplateId" value={sendMailData.TemplateId} onChange={handleSendMailChange} className="mail-select">
                                        <option value="">Select template</option>
                                        {mailTemplates.map((t, i) => <option key={i} value={t.MailTemplateId}>{t.MailTemplateName}</option>)}
                                    </select>
                                </div>
                            ) : (
                                <div className="mail-field-group"><textarea name="Body" placeholder="Body" value={sendMailData.Body} onChange={handleSendMailChange} className="mail-textarea"></textarea></div>
                            )}
                            <div className="mail-form-footer">
                                <button className="mail-reset-btn" onClick={onBack}>Cancel</button>
                                <button className="mail-save-btn" onClick={handleSendMail} disabled={isSubmitting}>{isSubmitting ? 'Sending...' : 'Save'}</button>
                            </div>
                        </div>
                    </div>
                );
            case 'sms':
                return (
                    <div className="add-followup-card send-mail-card">
                        <div className="add-followup-header send-mail-header"><h3>Send SMS</h3></div>
                        <div className="add-followup-body send-mail-body">
                            <div className="sms-tabs">
                                <button className={`sms-tab-btn ${smsTab === 'Indian SMS' ? 'active' : ''}`} onClick={() => setSmsTab('Indian SMS')}>Indian SMS</button>
                                <button className={`sms-tab-btn ${smsTab === 'NonIndian SMS' ? 'active' : ''}`} onClick={() => setSmsTab('NonIndian SMS')}>Non-Indian SMS</button>
                            </div>
                            <div className="mail-field-group">
                                <label className="mail-section-label">Mobile Numbers</label>
                                <div className="mail-checkbox-list">
                                    {[leadInfo?.MobileNo, leadInfo?.Phones].filter(Boolean).map(n => (
                                        <label className="mail-checkbox-item" key={n}>
                                            <input type="checkbox" name="ChooseNumbers" value={n} checked={sendSmsData.ChooseNumbers.includes(n)} onChange={handleSendSmsChange} /> {n}
                                        </label>
                                    ))}
                                </div>
                            </div>
                            <div className="mail-field-group">
                                <select name="Account" value={sendSmsData.Account} onChange={handleSendSmsChange} className="mail-select">
                                    <option value="">Select Account</option>
                                    {smsAccounts.map(acc => <option key={acc.Code} value={acc.Code}>{acc.Text}</option>)}
                                </select>
                            </div>
                            <div className="mail-field-group">
                                <select name="SenderId" value={sendSmsData.SenderId} onChange={handleSendSmsChange} className="mail-select">
                                    <option value="">-- Select SenderID --</option>
                                    {smsSenderIds.map((s, i) => <option key={i} value={s.SenderName || s.SenderId || s.Name}>{s.SenderName || s.SenderId || s.Name}</option>)}
                                </select>
                            </div>
                            <div className="mail-field-group">
                                <select name="TemplateId" value={sendSmsData.TemplateId} onChange={handleSendSmsChange} className="mail-select">
                                    <option value="">--Select Template--</option>
                                    {smsTemplates.map((tpl, i) => (
                                        <option key={i} value={tpl.MailTemplateId || tpl.Code || tpl.Id}>{tpl.MailTemplateName || tpl.Name || tpl.Text}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="mail-field-group">
                                <textarea name="Message" placeholder="Type your message here..." value={sendSmsData.Message} onChange={handleSendSmsChange} className="mail-textarea"></textarea>
                            </div>
                            <div className="mail-field-group">
                                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px' }}>
                                    <input type="checkbox" name="IsUnicode" checked={sendSmsData.IsUnicode} onChange={handleSendSmsChange} />
                                    IsUnicode
                                </label>
                            </div>
                            <div className="mail-form-footer">
                                <button className="mail-reset-btn" onClick={onBack}>Cancel</button>
                                <button className="mail-save-btn" onClick={handleSendSms} disabled={isSubmitting}>{isSubmitting ? 'Sending...' : 'Save'}</button>
                            </div>
                        </div>
                    </div>
                );
            case 'voice':
                return (
                    <div className="add-followup-card send-mail-card">
                        <div className="add-followup-header send-mail-header"><h3>Send Voice</h3></div>
                        <div className="add-followup-body send-mail-body">
                            <div className="mail-field-group">
                                <label className="mail-section-label">Choose Mobile Numbers</label>
                                <select
                                    name="ChooseNumbers"
                                    className="mail-select"
                                    value={sendVoiceData.ChooseNumbers[0] || ''}
                                    onChange={(e) => setSendVoiceData(prev => ({ ...prev, ChooseNumbers: [e.target.value] }))}
                                >
                                    <option value="">Select Number</option>
                                    {[leadInfo?.MobileNo, leadInfo?.Phones].filter(Boolean).map(n => (
                                        <option key={n} value={n}>{n}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="mail-field-group">
                                <select name="AppFlow" value={sendVoiceData.AppFlow} onChange={handleSendVoiceChange} className="mail-select">
                                    <option value="">Select App Flow</option>
                                    {appFlows.map(a => <option key={a.Code || a.AppId} value={a.Code || a.AppId}>{a.Text}</option>)}
                                </select>
                            </div>
                            <div className="voice-route-group" style={{ display: 'flex', gap: '20px', margin: '15px 0' }}>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                    <input type="radio" name="Route" value="promo" checked={sendVoiceData.Route === 'promo'} onChange={handleSendVoiceChange} />
                                    Promotional
                                </label>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                    <input type="radio" name="Route" value="trans" checked={sendVoiceData.Route === 'trans'} onChange={handleSendVoiceChange} />
                                    Transactional
                                </label>
                            </div>
                            <div className="mail-form-footer" style={{ marginTop: '20px' }}>
                                <button className="mail-reset-btn" onClick={() => setSendVoiceData({ ChooseNumbers: [], DnidNo: dniNumbers[0]?.Code || '', AppFlow: appFlows[0]?.Code || appFlows[0]?.AppId || '', Route: 'trans' })}>Reset</button>
                                <button className="mail-save-btn" onClick={handleSendVoice} disabled={isSubmitting}>{isSubmitting ? 'Saving...' : 'Save'}</button>
                            </div>
                        </div>
                    </div>
                );
            case 'notes':
                return (
                    <div className="add-followup-card">
                        <div className="add-followup-header"><h3>Add Note</h3></div>
                        <div className="add-followup-body">
                            <textarea placeholder="Type something..." value={notes} onChange={(e) => setNotes(e.target.value)} className="followup-textarea" style={{ height: '150px' }}></textarea>
                            <div className="form-footer">
                                <button className="reset-btn" onClick={onBack}>Cancel</button>
                                <button className="save-btn" onClick={handleAddNotes} disabled={isSubmitting}>Save</button>
                            </div>
                        </div>
                    </div>
                );
            case 'upload':
                return (
                    <div className="add-followup-card">
                        <div className="add-followup-header"><h3>Upload Document</h3></div>
                        <div className="add-followup-body">
                            <input type="file" onChange={handleFileChange} />
                            <div className="form-footer">
                                <button className="reset-btn" onClick={onBack}>Cancel</button>
                                <button className="save-btn" onClick={handleDocumentUpload} disabled={isSubmitting}>Upload</button>
                            </div>
                        </div>
                    </div>
                );
            case 'task':
                return (
                    <div className="add-followup-card send-mail-card">
                        <div className="add-followup-header send-mail-header"><h3>Add Task</h3></div>
                        <div className="add-followup-body send-mail-body">
                            <div className="mail-field-group">
                                <label className="mail-section-label">Title</label>
                                <input type="text" name="Title" value={addTaskData.Title} onChange={handleAddTaskChange} className="mail-input" placeholder="Title" />
                            </div>
                            <div className="mail-field-group">
                                <label className="mail-section-label">Description</label>
                                <textarea name="Description" value={addTaskData.Description} onChange={handleAddTaskChange} className="mail-textarea" placeholder="Start Typing the details about the task."></textarea>
                            </div>
                            <div className="mail-field-group">
                                <label className="mail-section-label">Remarks</label>
                                <textarea name="Remarks" value={addTaskData.Remarks} onChange={handleAddTaskChange} className="mail-textarea" placeholder="about the task..."></textarea>
                                <span style={{ fontSize: '11px', color: '#666' }}>2000 characters left</span>
                            </div>
                            <div className="mail-field-group">
                                <label className="mail-asterisk">Sales Activity Type</label>
                                <select name="SalesActivityType" value={addTaskData.SalesActivityType} onChange={handleAddTaskChange} className="mail-select">
                                    <option value="">Select Activity Type</option>
                                    {salesActivityOptions.map((o, idx) => <option key={idx} value={o.TasKId || o.Id || o.Value || o.Code}>{o.TasKName || o.Text || o.Name}</option>)}
                                </select>
                            </div>
                            <div className="mail-field-group">
                                <label className="mail-asterisk">Due Date and Time</label>
                                <div className="datetime-row">
                                    <input type="date" name="DueDate" value={addTaskData.DueDate} onChange={handleAddTaskChange} className="mail-input" />
                                    <input type="time" name="DueTime" value={addTaskData.DueTime} onChange={handleAddTaskChange} className="mail-input" />
                                </div>
                            </div>
                            <div className="mail-field-group">
                                <label className="mail-asterisk">Owner</label>
                                <select name="Owner" value={addTaskData.Owner} onChange={handleAddTaskChange} className="mail-select">
                                    <option value="">Select Owner</option>
                                    {assignedToOptions.map((o, i) => <option key={i} value={o.Code || o.ID || o.Id || o.Value}>{o.Text || o.Name}</option>)}
                                </select>
                            </div>
                            <div className="mail-field-group">
                                <label className="mail-section-label">Collaborators</label>
                                <select name="Collaborators" value={addTaskData.Collaborators} onChange={handleAddTaskChange} className="mail-select">
                                    <option value="">Select Collaborators</option>
                                    {collaboratorOptions.map((o, i) => <option key={i} value={o.Code || o.Value || o.Id || o.UserId}>{o.Text || o.Name || o.UserName}</option>)}
                                </select>
                            </div>
                            <div className="mail-form-footer">
                                <button className="mail-reset-btn" onClick={() => setAddTaskData({ ...addTaskData, Title: `NewTask_${new Date().toISOString().replace(/[-:T.Z]/g, '').slice(0, 14)}`, Description: '', Remarks: '', DueDate: new Date().toISOString().split('T')[0], DueTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }) })}>Reset</button>
                                <button className="mail-save-btn" onClick={handleAddTask} disabled={isSubmitting}>SAVE</button>
                            </div>
                        </div>
                    </div>
                );
            case 'appointment':
                return (
                    <div className="add-followup-card send-mail-card">
                        <div className="add-followup-header send-mail-header">
                            <h3>Add Appointment</h3>
                        </div>
                        <div className="add-followup-body send-mail-body">
                            <div className="mail-field-group">
                                <span className="mail-asterisk">*</span>
                                <label className="mail-section-label">Title</label>
                                <input type="text" name="Title" placeholder="Appointment Title" value={appointmentData.Title} onChange={handleAppointmentChange} className="mail-input" />
                            </div>
                            <div className="mail-field-group">
                                <label className="mail-section-label">Description</label>
                                <select name="ActivityType" value={appointmentData.ActivityType} onChange={handleAppointmentChange} className="mail-select" style={{ marginBottom: '10px' }}>
                                    <option value="">--Select Activity--</option>
                                    {salesActivityOptions.map((opt, i) => (
                                        <option key={i} value={opt.TasKId || opt.Id || opt.Code}>{opt.TasKName || opt.Text || opt.Name}</option>
                                    ))}
                                </select>
                                <textarea name="Description" placeholder="Start Typing the details about the appointment" value={appointmentData.Description} onChange={handleAppointmentChange} className="mail-textarea" style={{ height: '80px' }}></textarea>
                            </div>
                            <div className="mail-field-group">
                                <label className="mail-section-label">Remarks</label>
                                <div className="note-input-row">
                                    <textarea name="Remarks" placeholder="about the task..." value={appointmentData.Remarks} onChange={handleAppointmentChange} className="mail-textarea note-textarea" style={{ height: '60px' }}></textarea>
                                    <div className="note-char-counter">{2000 - (appointmentData.Remarks?.length || 0)} characters left</div>
                                </div>
                            </div>
                            <div className="mail-field-group">
                                <span className="mail-asterisk">*</span>
                                <label className="mail-section-label">Start Date and Time</label>
                                <div className="datetime-row">
                                    <input type="date" name="StartDate" value={appointmentData.StartDate} onChange={handleAppointmentChange} className="mail-input" />
                                    <input type="time" name="StartTime" value={appointmentData.StartTime} onChange={handleAppointmentChange} className="mail-input" />
                                </div>
                            </div>
                            <div className="mail-field-group">
                                <span className="mail-asterisk">*</span>
                                <label className="mail-section-label">End Date and Time</label>
                                <div className="datetime-row">
                                    <input type="date" name="EndDate" value={appointmentData.EndDate} onChange={handleAppointmentChange} className="mail-input" />
                                    <input type="time" name="EndTime" value={appointmentData.EndTime} onChange={handleAppointmentChange} className="mail-input" />
                                </div>
                            </div>
                            <div className="mail-field-group">
                                <span className="mail-asterisk">*</span>
                                <label className="mail-section-label">Where</label>
                                <input ref={whereInputRef} type="text" name="Where" placeholder="Enter location of appointment" value={appointmentData.Where} onChange={handleAppointmentChange} className="mail-input" />
                            </div>
                            <div className="mail-field-group">
                                <span className="mail-asterisk">*</span>
                                <label className="mail-section-label">Owner</label>
                                <select name="Owner" value={appointmentData.Owner} onChange={handleAppointmentChange} className="mail-select">
                                    <option value="">--Select Owner--</option>
                                    {assignedToOptions.map((opt, i) => <option key={i} value={opt.Code || opt.ID || opt.Id || opt.Value}>{opt.Text || opt.Name}</option>)}
                                </select>
                            </div>
                            <div className="mail-field-group">
                                <label className="mail-section-label">Collaborators</label>
                                <select name="Collaborators" value={appointmentData.Collaborators} onChange={handleAppointmentChange} className="mail-select">
                                    <option value="">--Select Collaborator--</option>
                                    {collaboratorOptions.map((opt, i) => <option key={i} value={opt.Code || opt.Value || opt.Id || opt.UserId}>{opt.Text || opt.Name || opt.UserName}</option>)}
                                </select>
                            </div>
                            <div className="mail-form-footer">
                                <button type="button" className="mail-reset-btn" onClick={() => setAppointmentData({
                                    Title: `NewAppointment_${new Date().toISOString().replace(/[-:T.Z]/g, '').slice(0, 14)}`,
                                    ActivityType: '8', Description: '', Remarks: '',
                                    StartDate: new Date().toISOString().split('T')[0],
                                    StartTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
                                    EndDate: new Date().toISOString().split('T')[0],
                                    EndTime: new Date(new Date().getTime() + 60 * 60 * 1000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
                                    Where: '', Latitude: '', Longitude: '', Owner: '41451', Collaborators: ''
                                })}>Reset</button>
                                <button className="mail-save-btn" onClick={handleSaveAppointment} disabled={isSubmitting}>{isSubmitting ? 'Saving...' : 'Save'}</button>
                            </div>
                        </div>
                    </div>
                );
            case 'deal':
                return (
                    <div className="deal-form-card">
                        <div className="deal-form-header">
                            <h3>Add Deal</h3>
                        </div>
                        <div className="deal-form-body">
                            <div className="deal-grid-container">
                                <div className="deal-input-group">
                                    <label>
                                        <span className="deal-label-asterisk">*</span> Deal value
                                    </label>
                                    <input
                                        type="number"
                                        name="Amount"
                                        placeholder="Please Enter Value"
                                        value={dealData.Amount}
                                        onChange={(e) => setDealData(prev => ({ ...prev, Amount: e.target.value }))}
                                        className="deal-input"
                                    />
                                </div>
                                <div className="deal-input-group">
                                    <label>Deal pipeline</label>
                                    <select
                                        name="PipelineId"
                                        value={dealData.PipelineId}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            setDealData(prev => ({ ...prev, PipelineId: val, PipelineStage: '' }));
                                            if (val) fetchDealStages(val);
                                        }}
                                        className="deal-select"
                                    >
                                        <option value="">--Select Pipeline--</option>
                                        {dealPipelines.map(pipe => (
                                            <option key={pipe.Code} value={pipe.Code}>{pipe.Text}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="deal-input-group">
                                    <label>Deal Stage</label>
                                    <select
                                        name="PipelineStage"
                                        value={dealData.PipelineStage}
                                        onChange={(e) => setDealData(prev => ({ ...prev, PipelineStage: e.target.value }))}
                                        className="deal-select"
                                    >
                                        <option value="">--Select Stage--</option>
                                        {dealStages.map((stage, idx) => (
                                            <option key={idx} value={stage.Code || stage.Id || stage.Value || stage.ID}>
                                                {stage.Text || stage.Name || stage.Value}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="deal-input-group">
                                    <label>Probability(%)*</label>
                                    <input
                                        type="number"
                                        name="Probability"
                                        placeholder="Enter Probability"
                                        value={dealData.Probability}
                                        onChange={(e) => setDealData(prev => ({ ...prev, Probability: e.target.value }))}
                                        className="deal-input"
                                    />
                                </div>
                                <div className="deal-input-group">
                                    <label>Sales owner</label>
                                    <select
                                        name="DealOwner"
                                        value={dealData.DealOwner}
                                        onChange={(e) => setDealData(prev => ({ ...prev, DealOwner: e.target.value }))}
                                        className="deal-select"
                                    >
                                        <option value="">--Select Owner--</option>
                                        {salesOwners.map(owner => (
                                            <option key={owner.Code} value={owner.Code}>{owner.Text}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="deal-input-group">
                                    <label>
                                        <span className="deal-label-asterisk">*</span> Estimated Closer Date
                                    </label>
                                    <input
                                        type="date"
                                        name="ClosureDate"
                                        value={dealData.ClosureDate}
                                        onChange={(e) => setDealData(prev => ({ ...prev, ClosureDate: e.target.value }))}
                                        className="deal-input"
                                    />
                                </div>
                            </div>
                            <div className="deal-footer-actions">
                                <button
                                    type="button"
                                    className="deal-btn-reset"
                                    onClick={() => setDealData({
                                        Amount: '',
                                        PipelineId: '',
                                        PipelineStage: '',
                                        Probability: '',
                                        DealOwner: '34594',
                                        ClosureDate: new Date().toISOString().split('T')[0]
                                    })}
                                >
                                    Reset
                                </button>
                                <button
                                    className="deal-btn-save"
                                    onClick={handleSaveDeal}
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? 'SAVING...' : 'SAVE'}
                                </button>
                            </div>
                        </div>
                    </div>
                );
            case 'fill-webform':
                return (
                    <div className="add-followup-card" style={{ border: 'none', boxShadow: 'none' }}>
                        <div className="add-followup-header" style={{ padding: '15px 20px', borderBottom: '1px solid #f0f0f0', backgroundColor: '#fafbfc' }}>
                            <h3 style={{ margin: 0, fontSize: '15px', color: '#313949', fontWeight: '600' }}>Fill Webform</h3>
                        </div>
                        <div className="add-followup-body" style={{ padding: '20px' }}>
                            <div className="form-group" style={{ marginBottom: '20px' }}>
                                <label style={{ display: 'block', fontSize: '13px', color: '#5b6289', fontWeight: '500', marginBottom: '8px' }}>*Webform Name</label>
                                <select
                                    name="WebformId"
                                    value={selectedWebform}
                                    onChange={(e) => setSelectedWebform(e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '10px 12px',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        fontSize: '13px',
                                        color: '#555',
                                        outline: 'none',
                                        backgroundColor: '#fff',
                                        cursor: 'pointer'
                                    }}
                                >
                                    <option value="">--Select Webform--</option>
                                    {webforms.map(form => (
                                        <option key={form.Id} value={form.Id}>{form.Text}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="form-footer" style={{ display: 'flex', justifyContent: 'flex-end', gap: '15px', padding: '15px 0 0 0', borderTop: '1px solid #f0f0f0', margin: 0 }}>
                                <button
                                    onClick={() => setSelectedWebform('')}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        color: '#5b6289',
                                        fontSize: '13px',
                                        cursor: 'pointer',
                                        padding: '8px 15px'
                                    }}
                                >
                                    Reset
                                </button>
                                <button
                                    onClick={() => {
                                        if (!selectedWebform) {
                                            alert("Please select a webform");
                                            return;
                                        }
                                        const form = webforms.find(f => f.Id == selectedWebform);
                                        if (form) {
                                            const leadId = task.LeadId || task.enquiryId || task.leadId || task.id || "2508095";
                                            const url = `https://kit19.com/UserCRMCampaign/webFormDetails.aspx?ParentID=34594&cName=${encodeURIComponent(form.Text)}&EntityName=Lead&AgentId=34594&EntityId=${leadId}`;
                                            window.open(url, '_blank');
                                            onSuccess?.();
                                        }
                                    }}
                                    style={{
                                        backgroundColor: '#fff',
                                        border: '1px solid #28a745',
                                        color: '#28a745',
                                        fontWeight: '600',
                                        padding: '8px 30px',
                                        borderRadius: '4px',
                                        fontSize: '13px',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    SAVE
                                </button>
                            </div>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className="operations-forms-container">
            {renderForm()}
        </div>
    );
};

export default OperationsForms;
